var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Tag } from '@/models/Tag';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import AddTagDialog from '@/views/Tags/AddTagDialog';
import ErrorHandler from '@/support/ErrorHandler';
let Tags = class Tags extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Tags';
        this.selected = [];
        this.selectedTag = null;
        this.isCreatingTag = false;
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('tag.title', 1),
                plural: this.$tc('tag.title', 2),
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    editable: true,
                    changed: false,
                },
            ],
            actions: [
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, tag) => {
                        this.selectedTag = tag;
                        this.$store.dispatch('openDialog', this.dialogOptions);
                    },
                },
            ],
            filters: [],
            dropdown: [],
            model: new Tag(),
        };
    }
    get dialogOptions() {
        const tag = this.selectedTag;
        return {
            title: tag.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, { item: this.$t('dialogOptions.item.tag') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!tag) {
                            return;
                        }
                        tag
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.selectedTag = new Tag();
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedTag = new Tag();
                    },
                },
            },
        };
    }
    handleTableEdit(dataTable, tag) {
        //
    }
    refreshDataTable() {
        this.refreshTagStore();
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    refreshTagStore() {
        new Tag()
            .all()
            .then((tags) => {
            this.$store.dispatch('loadedTags', tags);
        })
            .catch(() => { });
    }
};
Tags = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            AddTagDialog,
        },
    })
], Tags);
export default Tags;
